module.exports = __webpack_public_path__ + "img/42471c0.jpg";